import type { CvTemplate } from '../types';

// Source unique de vérité des templates de CV : ajouter un template = une entrée ici
// + son rendu dans CvPreview et buildCvHtml.

export const DEFAULT_TEMPLATE: CvTemplate = 'mono';

export const TEMPLATE_CATEGORIES = ['Tous', 'Sobre', 'Coloré', 'Créatif', 'Premium'] as const;
export type TemplateCategory = (typeof TEMPLATE_CATEGORIES)[number];

export interface TemplateMeta {
  key: CvTemplate; // clé technique (stockée en base, ne change jamais) — distincte du label affiché
  label: string; // libellé affiché à l'utilisateur
  category: TemplateCategory;
  recommended?: boolean; // choix le plus sûr (sobre, compatible ATS)
}

export const TEMPLATES: TemplateMeta[] = [
  { key: 'mono', label: 'Professionnel', category: 'Sobre', recommended: true },
  { key: 'accent', label: 'Coloré', category: 'Coloré' },
];

// Libellé affiché d'un template depuis sa clé technique (source unique de vérité).
export function templateLabel(key: CvTemplate): string {
  return TEMPLATES.find((t) => t.key === key)?.label ?? key;
}

export interface AccentColor {
  label: string;
  hex: string;
}

// Palette prédéfinie (pas de sélecteur libre) pour la teinte du template « accent ».
export const ACCENT_COLORS: AccentColor[] = [
  { label: 'Lime', hex: '#96CD32' },
  { label: 'Vert', hex: '#00965E' },
  { label: 'Bleu', hex: '#003DA5' },
  { label: 'Beige', hex: '#C8B89A' },
  { label: 'Marron', hex: '#7B5E3B' },
  { label: 'Ardoise', hex: '#4A5568' },
  { label: 'Marine', hex: '#1B2A4A' },
];

export const DEFAULT_ACCENT = '#96CD32';

// Couleur de texte lisible (blanc/noir) sur un fond d'accent donné, selon sa luminance perçue.
export function readableOn(hex: string): '#FFFFFF' | '#111111' {
  const h = hex.replace('#', '');
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? '#111111' : '#FFFFFF';
}
